import { render, staticRenderFns } from "./AdminUserGames.vue?vue&type=template&id=4f57415f&scoped=true"
import script from "./AdminUserGames.vue?vue&type=script&lang=js"
export * from "./AdminUserGames.vue?vue&type=script&lang=js"
import style0 from "./AdminUserGames.vue?vue&type=style&index=0&id=4f57415f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f57415f",
  null
  
)

export default component.exports